export default "__VITE_ASSET__EVIYIHQh__"